import { render, staticRenderFns } from "./DoctorAppointmentStub.vue?vue&type=template&id=59019acb&scoped=true&"
import script from "./DoctorAppointmentStub.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorAppointmentStub.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorAppointmentStub.vue?vue&type=style&index=0&id=59019acb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59019acb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59019acb')) {
      api.createRecord('59019acb', component.options)
    } else {
      api.reload('59019acb', component.options)
    }
    module.hot.accept("./DoctorAppointmentStub.vue?vue&type=template&id=59019acb&scoped=true&", function () {
      api.rerender('59019acb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorAppointmentStub.vue"
export default component.exports